import { render, staticRenderFns } from "./SynQuestDataField.vue?vue&type=template&id=3c8d242d&scoped=true"
import script from "./SynQuestDataField.vue?vue&type=script&lang=ts"
export * from "./SynQuestDataField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d242d",
  null
  
)

export default component.exports